import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Type } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;

export const TextVideoDialog = ({ asset, onClose, onStarted }) => {
  const [f, setF] = useState({ title: "", price: "", cta: "Comandă pe bragus.ro" });
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.post(`${API}/${asset.id}/text-video/suggest`).then((r) => setF(r.data)).catch((e) => toast.error(e.response?.data?.detail || e.message)).finally(() => setLoading(false));
  }, [asset.id]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const go = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/${asset.id}/text-video`, f);
      toast.success("Adaug textul animat — video-ul nou apare în ~1 minut");
      onStarted(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="text-video-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Text animat pe video</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500">Titlul apare sus, apoi prețul și îndemnul, pe rând, cu animație. Merge cel mai bine pe clipuri fără text. Video-ul original rămâne în galerie. Gratuit.</p>
        {loading ? <Loader2 className="h-4 w-4 animate-spin text-zinc-400" /> : (
          <div className="space-y-2">
            <label className="block text-xs text-zinc-600">Titlu<Input data-testid="text-video-title" value={f.title} onChange={set("title")} maxLength={80} className="mt-1" /></label>
            <label className="block text-xs text-zinc-600">Preț (gol = fără)<Input data-testid="text-video-price" value={f.price} onChange={set("price")} maxLength={30} className="mt-1" /></label>
            <label className="block text-xs text-zinc-600">Îndemn (gol = fără)<Input data-testid="text-video-cta" value={f.cta} onChange={set("cta")} maxLength={40} className="mt-1" /></label>
          </div>
        )}
        <button data-testid="text-video-generate-btn" onClick={go} disabled={busy || loading || !f.title.trim()}
          className="flex items-center justify-center gap-2 rounded-full bg-amber-400 py-2.5 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Type className="h-4 w-4" />} Pune textul pe video
        </button>
      </DialogContent>
    </Dialog>
  );
};
